import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const resendEnvelope = createAsyncThunk(
  "Docs/resendEnvelope",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.post(
        `${process.env.REACT_APP_BASE_URL}api/docs/folders/${data?.id}/signing-envelopes/resend/${data?.envelope_id}`,
        { ...data.schema },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (data?.handleSuccess) {
        data?.handleSuccess();
      }
      return resp.data;
    } catch (error) {
      if (error.response) {
        if (data?.handleError) {
          data?.handleError(
            error.response.data.errorMessage || error.response.data.message
          );
        }
        return thunkAPI.rejectWithValue(
          error.response.data.errorMessage || error.response.data.message
        );
      } else {
        if (data?.handleError) {
          data?.handleError(error.message);
        }
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
